module.exports = __webpack_public_path__ + "img/galleria1.6645e17e.jpg";